(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7710],{

/***/ 35532:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* reexport safe */ _firebase_app__WEBPACK_IMPORTED_MODULE_0__.Z; }
/* harmony export */ });
/* harmony import */ var _firebase_app__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87964);



var name = "firebase";
var version = "8.10.1";

/**
 * @license
 * Copyright 2018 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
_firebase_app__WEBPACK_IMPORTED_MODULE_0__/* ["default"].registerVersion */ .Z.registerVersion(name, version, 'app');
_firebase_app__WEBPACK_IMPORTED_MODULE_0__/* ["default"].SDK_VERSION */ .Z.SDK_VERSION = version;
//# sourceMappingURL=index.esm.js.map


/***/ }),

/***/ 51384:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"login"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LoginUserInput"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"login"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserInfo"},"directives":[]},{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"violations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":285}};
    doc.loc.source = {"body":"#import \"./User.graphql\"\nmutation login($input: LoginUserInput!){\n  login(input:$input){\n    entity{\n      ...UserInfo\n      ... on User{\n        session{\n          key\n          value\n        }\n      }\n    }\n    errors\n    violations {\n      message\n      path\n      code\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique((__webpack_require__(96577).definitions)));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.login = oneQuery(doc, "login");
        


/***/ }),

/***/ 44909:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"firebase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"input"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"res"},"name":{"kind":"Name","value":"firebase"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"input"},"value":{"kind":"Variable","name":{"kind":"Name","value":"input"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entity"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"InlineFragment","typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"session"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"key"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"violations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":245}};
    doc.loc.source = {"body":"mutation firebase($input: String!){\n  res:firebase(input: $input){\n    entity{\n      ... on User{\n        session{\n          key\n          value\n        }\n      }\n    }\n    errors\n    violations {\n      message\n      path\n      code\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.firebase = oneQuery(doc, "firebase");
        


/***/ }),

/***/ 81998:
/***/ (function(module) {


    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"firebase"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"providerID"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},"directives":[]},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}},"directives":[]}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"res"},"name":{"kind":"Name","value":"firebaseDisconnect"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"provider_id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"providerID"}}},{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"errors"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"violations"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"message"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"path"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"code"},"arguments":[],"directives":[]}]}}]}}]}}],"loc":{"start":0,"end":208}};
    doc.loc.source = {"body":"  mutation firebase($providerID: String!, $id: Int){\n    res:firebaseDisconnect(provider_id: $providerID, id: $id){\n      errors\n      violations {\n        message\n        path\n        code\n      }\n    }\n  }\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports.firebase = oneQuery(doc, "firebase");
        


/***/ }),

/***/ 97710:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PO": function() { return /* binding */ withFirebaseProcess; }
/* harmony export */ });
/* unused harmony export withFirebase */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _mui_material_Box__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24862);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35532);
/* harmony import */ var recompose_compose__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7725);
/* harmony import */ var recompose_withProps__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(72822);
/* harmony import */ var _xem_user_common_classes_withUserCount__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(60931);
/* harmony import */ var _xem_user_common_classes_firebase__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72446);








const withFirebaseProcess = (0,recompose_compose__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_xem_user_common_classes_withUserCount__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)("userCount"), (0,recompose_withProps__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((param)=>{
    let { signInWithPhoneNumber , element , connectWithRefreshToken  } = param;
    const [view, setState] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [viewConfirm, setStateConfirm] = react__WEBPACK_IMPORTED_MODULE_1__.useState(false);
    const [confirmationResult, setConfirmationResult] = react__WEBPACK_IMPORTED_MODULE_1__.useState(null);
    return {
        view,
        viewConfirm,
        confirmationResult,
        setConfirmationResult,
        onDisplay: ()=>setState(!view),
        onDisplayConfirm: ()=>setStateConfirm(!viewConfirm),
        signInWithPhoneNumber: async (phone)=>signInWithPhoneNumber({
                phone,
                element,
                setConfirmationResult
            })
    };
}));
/**
 *
 * @param Component
 * @returns {function({element: *, firebaseSettings: *, [p: string]: *}): *}
 */ const withFirebase = (Component)=>(param)=>{
        let { firebaseSettings , ...props } = param;
        let element = react__WEBPACK_IMPORTED_MODULE_1__.useRef(null);
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_xem_user_common_classes_firebase__WEBPACK_IMPORTED_MODULE_6__/* .FirebaseAuthProvider */ .Gk, {
            ...firebaseSettings,
            firebase: firebase_app__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Component, {
                    ...props,
                    element: element
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material_Box__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                    sx: {
                        display: "none"
                    },
                    id: "element",
                    ref: element
                })
            ]
        });
    };
/* harmony default export */ __webpack_exports__["ZP"] = (withFirebase);


/***/ }),

/***/ 5840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "vU": function() { return /* binding */ withFirebaseAuth; }
/* harmony export */ });
/* unused harmony exports withFirebaseConnect, withFirebaseDisConnect */
/* harmony import */ var react_apollo__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(50133);
/* harmony import */ var _graphql_social_socialDisconnect_graphql__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(81998);
/* harmony import */ var _graphql_social_socialDisconnect_graphql__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_graphql_social_socialDisconnect_graphql__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _graphql_social_firebase_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44909);
/* harmony import */ var _graphql_social_firebase_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_graphql_social_firebase_graphql__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var recompose_compose__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7725);
/* harmony import */ var recompose_withProps__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(72822);
/* harmony import */ var _gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(20402);
/* harmony import */ var _gqlapp_base_utils_saveStatus__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(63477);
/* harmony import */ var firebase_app__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(35532);
/* harmony import */ var _withUserLogin__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55546);










const withFirebaseConnect = (0,react_apollo__WEBPACK_IMPORTED_MODULE_6__/* .graphql */ .BX)((_graphql_social_firebase_graphql__WEBPACK_IMPORTED_MODULE_1___default()), {
    props: (param)=>{
        let { mutate  } = param;
        return {
            fbConnect: async (variables)=>(0,_gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(await mutate({
                    variables
                }), (param)=>{
                    let { data  } = param;
                    return data;
                }), (param)=>{
                    let { res  } = param;
                    return res;
                })
        };
    }
});
const withFirebaseDisConnect = (0,react_apollo__WEBPACK_IMPORTED_MODULE_6__/* .graphql */ .BX)((_graphql_social_socialDisconnect_graphql__WEBPACK_IMPORTED_MODULE_0___default()), {
    props: (param)=>{
        let { mutate  } = param;
        return {
            fbDisconnect: async (variables)=>(0,_gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(await mutate({
                    variables
                }), (param)=>{
                    let { data  } = param;
                    return data;
                }), (param)=>{
                    let { res  } = param;
                    return res;
                })
        };
    }
});
// @ts-ignore
const withFirebaseAuth = (0,recompose_compose__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(react_apollo__WEBPACK_IMPORTED_MODULE_6__/* .withApollo */ .CG, _withUserLogin__WEBPACK_IMPORTED_MODULE_5__/* .withLoginQuery */ .m2, withFirebaseConnect, withFirebaseDisConnect, (0,recompose_withProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((param)=>{
    let { fbConnect: action , loginAction , connectAction , client  } = param;
    return {
        getToken: ()=>new Promise(async (resolve)=>firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().currentUser.getIdToken(true).then(async (idToken)=>resolve(idToken))// @ts-ignore
                .catch(()=>resolve())),
        signInWithRefreshToken: (refreshToken)=>loginAction({
                action,
                client,
                variables: {
                    input: refreshToken
                },
                // @ts-ignore
                errorMsg: "login.errorMsg".t()
            }).catch(errorCatch),
        connectWithRefreshToken: (refreshToken)=>connectAction({
                action,
                client,
                history,
                variables: {
                    input: refreshToken
                },
                // @ts-ignore
                errorMsg: "login.errorMsg".t()
            }).catch(errorCatch)
    };
}), (0,recompose_withProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((param)=>{
    let { signInWithRefreshToken , connectWithRefreshToken , refetch  } = param;
    return {
        auth: async (param)=>{
            let { rest  } = param;
            return rest.then(async (res)=>{
                var ref;
                return signInWithRefreshToken(res === null || res === void 0 ? void 0 : (ref = res.user) === null || ref === void 0 ? void 0 : ref.refreshToken);
            }).catch(errorCatch);
        },
        connect: async (param)=>{
            let { rest  } = param;
            return rest.then(async (res)=>{
                var ref;
                await connectWithRefreshToken(res === null || res === void 0 ? void 0 : (ref = res.user) === null || ref === void 0 ? void 0 : ref.refreshToken);
                refetch && refetch();
            }).catch(errorCatch);
        }
    };
}), (0,recompose_withProps__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((param)=>{
    let { auth , connect , fbDisconnect , refetch  } = param;
    return {
        signInWithPhoneNumber: async (param)=>{
            let { phone , element , setConfirmationResult  } = param;
            element.current.innerHTML = '<div id="recaptcha-container"/>';
            let recaptcha = new firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth.RecaptchaVerifier */ .Z.auth.RecaptchaVerifier("recaptcha-container", {
                size: "invisible"
            });
            await recaptcha.verify().then(async ()=>{
                firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().signInWithPhoneNumber(phone, recaptcha).then((res)=>{
                    recaptcha.clear();
                    setConfirmationResult(res);
                }).catch(errorCatch);
            }).catch(errorCatch);
        },
        /**
     * firebaseDisconnect
     * @param variables
     */ firebaseDisconnect: async (variables)=>{
            try {
                // @ts-ignore
                (0,_gqlapp_base_utils_saveStatus__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                    values: await fbDisconnect(variables),
                    errorMsg: "Unknown error.".t()
                });
                refetch && refetch();
            } catch (e) {
                errorCatch(e);
            }
        },
        signInWithGoogle: async ()=>{
            const authProvider = new firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth.GoogleAuthProvider */ .Z.auth.GoogleAuthProvider();
            return auth({
                rest: firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().signInWithPopup(authProvider)
            });
        },
        signInWithFacebook: async ()=>{
            const authProvider = new firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth.FacebookAuthProvider */ .Z.auth.FacebookAuthProvider();
            return auth({
                rest: firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().signInWithPopup(authProvider)
            });
        },
        connectWithGoogle: async ()=>{
            const authProvider = new firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth.GoogleAuthProvider */ .Z.auth.GoogleAuthProvider();
            return connect({
                rest: firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().signInWithPopup(authProvider)
            });
        },
        connectWithFacebook: async ()=>{
            const authProvider = new firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth.FacebookAuthProvider */ .Z.auth.FacebookAuthProvider();
            return connect({
                rest: firebase_app__WEBPACK_IMPORTED_MODULE_4__/* ["default"].auth */ .Z.auth().signInWithPopup(authProvider)
            });
        }
    };
}));


/***/ }),

/***/ 72446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Gk": function() { return /* reexport */ FirebaseAuthProvider; },
  "vU": function() { return /* reexport */ firebaseOperations/* withFirebaseAuth */.vU; }
});

// UNUSED EXPORTS: FirebaseAuthConsumer, IfFirebaseAuthed, IfFirebaseAuthedAnd, IfFirebaseAuthedOr, IfFirebaseUnAuthed, WithFirebase, withFirebaseConnect, withFirebaseDisConnect

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/lodash/get.js
var get = __webpack_require__(72579);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
;// CONCATENATED MODULE: ../../node_modules/render-and-add-props/dist/index.esm.js


var index_esm_renderAndAddProps = function (renderable, props) {
    if (typeof renderable === "function") {
        return renderable(props);
    }
    else if (react.Children.count(renderable) > 0) {
        return react.Children.map(renderable, function (child) {
            return (0,react.cloneElement)(child, props);
        });
    }
    else if ((0,react.isValidElement)(renderable)) {
        return (0,react.cloneElement)(renderable, props);
    }
    return null;
};

/* harmony default export */ var index_esm = ((/* unused pure expression or super */ null && (index_esm_renderAndAddProps)));


;// CONCATENATED MODULE: ../modules/user/common/classes/firebase/initialize-firebase-app.ts
const initializeFirebaseApp = (param)=>{
    let { firebase , authDomain , databaseURL , projectId , storageBucket , messagingSenderId , apiKey , appId , measurementId  } = param;
    try {
        firebase.initializeApp({
            apiKey,
            authDomain,
            databaseURL,
            projectId,
            storageBucket,
            messagingSenderId,
            appId,
            measurementId
        });
    } catch (err) {
    // console.warn('###XXX###', { err });
    }
};

;// CONCATENATED MODULE: ../modules/user/common/classes/firebase/firebase.tsx





const firebaseAuthProviderDefaultProps = {
    isSignedIn: false,
    providerId: null,
    user: null,
    firebase: {}
};
const { Provider: FirebaseAuthContextProvider , Consumer: FirebaseAuthContextConsumer  } = /*#__PURE__*/ react.createContext(firebaseAuthProviderDefaultProps);
class FirebaseAuthProvider extends react.PureComponent {
    componentDidMount() {
        this.listenToAuth();
    }
    componentWillUnmount() {
        // tslint:disable-next-line:no-unused-expression
        this.stopListeningToAuth && this.stopListeningToAuth();
    }
    render() {
        // @ts-ignore
        const { children , apiKey  } = this.props;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !!apiKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(FirebaseAuthContextProvider, {
                    value: this.state,
                    children: index_esm_renderAndAddProps(children, {})
                }),
                !apiKey && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: children
                })
            ]
        });
    }
    constructor(props){
        super(props);
        // @ts-ignore
        this.state = {
            isSignedIn: false,
            providerId: null,
            user: null,
            firebase: {}
        };
        this.listenToAuth = ()=>{
            const { firebase  } = this.props;
            try {
                this.stopListeningToAuth = firebase.app().auth().onAuthStateChanged((user)=>{
                    let authEmission = null;
                    if (user === null) {
                        authEmission = {
                            isSignedIn: false,
                            providerId: "none",
                            user,
                            firebase
                        };
                    } else if (user.isAnonymous === true) {
                        authEmission = {
                            isSignedIn: true,
                            providerId: "anonymous",
                            user,
                            firebase
                        };
                    } else if (user.providerData && user.providerData[0]) {
                        authEmission = {
                            isSignedIn: true,
                            providerId: get_default()(user, "providerData.0.providerId", "unknown"),
                            user,
                            firebase
                        };
                    }
                    if (authEmission !== null) {
                        this.setState(()=>authEmission);
                    } else {
                        console.error("Something unexpected happened with ", user);
                    }
                });
            } catch (e) {}
        };
        if (props.apiKey) {
            initializeFirebaseApp({
                ...props
            });
        }
    }
}
// export type RenderableFunction<> = () => {}
// @ts-ignore
const FirebaseAuthConsumer = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(FirebaseAuthContextConsumer, {
        children: (authState)=>renderAndAddProps(children, authState)
    });
};
// @ts-ignore
const IfFirebaseAuthed = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(FirebaseAuthContextConsumer, {
        children: (authState)=>authState.isSignedIn === true ? renderAndAddProps(children, authState) : null
    });
};
// @ts-ignore
const IfFirebaseAuthedAnd = (param)=>{
    let { children , filter  } = param;
    return /*#__PURE__*/ _jsx(FirebaseAuthContextConsumer, {
        children: (authState)=>authState.isSignedIn === true ? filter(authState) ? renderAndAddProps(children, authState) : null : null
    });
};
// @ts-ignore
const IfFirebaseAuthedOr = (param)=>{
    let { children , filter  } = param;
    return /*#__PURE__*/ _jsx(FirebaseAuthContextConsumer, {
        children: (authState)=>authState.isSignedIn === true || filter(authState) ? renderAndAddProps(children, authState) : null
    });
};
// @ts-ignore
const IfFirebaseUnAuthed = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(FirebaseAuthContextConsumer, {
        children: (authState)=>authState.isSignedIn === false ? renderAndAddProps(children, authState) : null
    });
};
const WithFirebase = (param)=>{
    let { children  } = param;
    return /*#__PURE__*/ _jsx(FirebaseAuthContextConsumer, {
        children: children
    });
};

// EXTERNAL MODULE: ../modules/user/common/classes/firebase/firebaseOperations.ts
var firebaseOperations = __webpack_require__(5840);
;// CONCATENATED MODULE: ../modules/user/common/classes/firebase/index.ts




/***/ }),

/***/ 55546:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m2": function() { return /* binding */ withLoginQuery; }
/* harmony export */ });
/* unused harmony export withUserLogin */
/* harmony import */ var react_apollo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(50133);
/* harmony import */ var recompose_withProps__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72822);
/* harmony import */ var _graphql_Login_graphql__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51384);
/* harmony import */ var _graphql_Login_graphql__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_graphql_Login_graphql__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(20402);
/* harmony import */ var _gqlapp_base_utils_loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98213);
/* harmony import */ var _gqlapp_base_utils_saveStatus__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63477);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);







const withUserLogin = (0,react_apollo__WEBPACK_IMPORTED_MODULE_3__/* .graphql */ .BX)((_graphql_Login_graphql__WEBPACK_IMPORTED_MODULE_1___default()), {
    // @ts-ignore
    props: (param)=>{
        let { mutate , ownProps: { loadbar  }  } = param;
        return {
            // @ts-ignore
            login: async (param)=>{
                let { usernameOrEmail , password  } = param;
                return (0,_gqlapp_base_utils_loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(loadbar, async ()=>(0,_gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_gqlapp_base_utils_map__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(await mutate({
                        variables: {
                            input: {
                                usernameOrEmail,
                                password
                            }
                        }
                    }), (param)=>{
                        let { data  } = param;
                        return data;
                    }), (param)=>{
                        let { login: res  } = param;
                        return res;
                    }));
            }
        };
    }
});
const withLoginQuery = (0,recompose_withProps__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((param)=>{
    let { currentUser  } = param;
    const doLogin = async (param)=>{
        let { key , value  } = param;
        let allCookies = getCookies();
        let keys = Object.keys(allCookies) || [];
        keys.filter((k)=>new RegExp(RegExp("(SESS|SSESS)(.*)", "s")).test(k)).map(function(value) {
            deleteCookie(value);
        });
        await setCookie(key, value);
        setTimeout(()=>next_router__WEBPACK_IMPORTED_MODULE_2___default().reload(), 500);
    };
    const connectAction = async (param)=>{
        let { action , errorMsg , variables: input  } = param;
        (0,_gqlapp_base_utils_saveStatus__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            values: await action(input),
            errorMsg
        });
    };
    const loginAction = async (param)=>{
        let { action , errorMsg , variables  } = param;
        let { entity: { session , ...userData }  } = (0,_gqlapp_base_utils_saveStatus__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            values: await action(variables),
            errorMsg
        });
        currentUser.save(userData || {});
        await doLogin(session);
    };
    return {
        doLogin,
        loginAction,
        connectAction
    };
});
/* harmony default export */ __webpack_exports__["ZP"] = (withUserLogin);


/***/ })

}]);